export default __webpack_public_path__ + "static/media/Schuster.ae5b33d8.png";